import { lazy } from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import DeleteGroupPage from 'modules/posts/pages/DeleteGroupPage'
import EditGroupPage from 'modules/posts/pages/EditGroupPage'
import JoinGroupPage from 'modules/posts/pages/JoinGroupPage'
import LeaveGroupPage from 'modules/posts/pages/LeaveGroupPage'
import NewGroupPage from 'modules/posts/pages/NewGroupPage'

const RootPage = lazy(() => import('modules/posts/pages/GroupsRootPage'))

const groupsRoutes: NavigationRoutesFn = (navigation) => [
  {
    path: navigation.dashboard.groups.path,
    element: <RootPage />,
    children: [
      {
        path: navigation.dashboard.groups.new.path,
        element: <NewGroupPage />,
      },
      {
        path: navigation.dashboard.groups.join.path,
        element: <JoinGroupPage />,
      },
      {
        path: navigation.dashboard.groups.id.path,
        children: [
          {
            path: navigation.dashboard.groups.id.leave.path,
            element: <LeaveGroupPage />,
          },
          {
            path: navigation.dashboard.groups.id.edit.path,
            element: <EditGroupPage />,
          },
          {
            path: navigation.dashboard.groups.id.delete.path,
            element: <DeleteGroupPage />,
          },
        ],
      },
    ],
  },
]

export default groupsRoutes
